import type { CircleShape as CircleShapeType } from '@/features/comment-on-file';
import { strokeWidthFor } from './strokeWidths';

interface Props {
  shape: CircleShapeType;
  color: string;
  focused?: boolean;
  halo?: boolean;
}

export function CircleShape({ shape, color, focused, halo }: Props) {
  const { x, y, w, h } = shape.rect;
  const nx = w < 0 ? x + w : x;
  const ny = h < 0 ? y + h : y;
  const nw = Math.abs(w);
  const nh = Math.abs(h);
  const rx = nw / 2;
  const ry = nh / 2;
  const cx = nx + rx;
  const cy = ny + ry;
  const strokeWidth = strokeWidthFor('circle', { focused, halo });
  return (
    <ellipse
      cx={cx}
      cy={cy}
      rx={rx}
      ry={ry}
      fill="transparent"
      stroke={color}
      strokeWidth={strokeWidth}
      vectorEffect="non-scaling-stroke"
    />
  );
}
